import menuMobile from './module/menuMobile.js'
import scrollMarkers from './module/scrollMarkers.js'
// import customSwiper from './module/customSwiper.js'
import modal from './module/modal.js'
import bookingWidget from './module/booking.js'
import contactForm from './module/contactForm.js'
// import initVtModal from './module/vt-modal.js'
import cookies from './module/cookies.js'
import darkModeOS from './module/darkModeOS.js'
import animations from './module/animations.js'
import lazyLoader from './module/lazyLoader.js'
import preventZoom from './module/preventZoom.js'
import alertRotateDevice from './module/alertRotateDevice.js'
// import tabs from './module/tabs.js'
// import customRellax from './module/customRellax.js';
// import getUrlParams from './module/getUrlParams.js';

function functions (deviceData) { // Only One Param if not using Barba.js
  // console.log(deviceData);
  import('./module/lenisScroll.js')
    .then(({ default: lenisScroll }) => {
      lenisScroll()
    })
    .catch((error) => {
      console.error('Lenis initialization failed', error)
    })

  menuMobile(deviceData)
  scrollMarkers(deviceData)
  darkModeOS(cookies)
  contactForm()
  animations()
  lazyLoader()
  if (deviceData.page === 'home') {
    import('./module/gsap.js')
      .then(({ letterAnim }) => {
        letterAnim(deviceData)
      })
      .catch(() => {})
  }
  preventZoom()
  alertRotateDevice(deviceData.isDesktop, deviceData.isBigTablet, deviceData.isMobile)
  bookingWidget()
  modal()
}

export default functions
